module.exports = __webpack_public_path__ + "img/xuanzhuan_icon.3c7a9667.svg";